// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\TaggedCommentUser\ApiTaggedCommentUser.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Comment, CommentData, CommentOptions } from 'data/models/Comment';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';

// TaggedCommentUserData is the class that TaggedCommentUser serializes to/from
export interface TaggedCommentUserData {
    CommentId : number;
    UserId : number;
	
    Comment : CommentData | null;
    User : PCUserData | null;
	
}

// TaggedCommentUserOptions is the class which may be passed to the TaggedCommentUser constructor to define optional initial data values
export interface TaggedCommentUserOptions {
    CommentId : number;
    UserId : number;
	
    Comment? : CommentOptions | null;
    User? : PCUserOptions | null;
	
}

export class TaggedCommentUser {
    public CommentId : DataSignal<number>;
    public UserId : DataSignal<number>;
	
    public Comment : DataSignal<Comment | null>;
    public User : DataSignal<PCUser | null>;
	

    constructor();
    constructor(data : TaggedCommentUserOptions);
    constructor(data: TaggedCommentUserOptions | null = null) {
        this.CommentId = jsonableObservable(S.value<number>(data && data.CommentId !== undefined ? data.CommentId : 0));
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.Comment = S.value<Comment | null>(null);
        this.User = S.value<PCUser | null>(null);
	    
    }

    static key(obj : TaggedCommentUser) {
        return obj.CommentId() + '\u2618' + obj.UserId();
    }
    
    static dataKey(obj : TaggedCommentUserOptions) {
        return obj.CommentId + '\u2618' + obj.UserId;
    }

    static update(obj : TaggedCommentUser, data : TaggedCommentUserOptions) {
        S.freeze(() => {
            if (data.CommentId !== undefined) obj.CommentId(data.CommentId);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TaggedCommentUser.ts